import React, { useState } from "react";
import { TextInput } from "../../../controls";
import { SCHEDULE_END_TYPES, type ScheduleEndType } from "../SchedulerUtils";

interface ScheduleEndAfterChange {
  type: ScheduleEndType;
  data: number;
}

interface ScheduleEndAfterProps {
  initialValue?: number | string;
  onChange: (change: ScheduleEndAfterChange) => void;
}

const ScheduleEndAfter = ({ initialValue, onChange }: ScheduleEndAfterProps) => {
  const [value, setValue] = useState<number | string | undefined>(initialValue);
  return (
    <div className="end-after-container">
      <TextInput
        size={"xxs"}
        type="number"
        value={value?.toString() || undefined}
        onChange={(e: { target: { value: string } }) => {
          setValue(e.target.value);
          onChange({
            type: SCHEDULE_END_TYPES.AFTER,
            data: parseInt(e.target.value),
          });
        }}
        placeholder="# of times"
        data-testid="schedule-end-after-text-input"
      />
      <span className="times">times</span>
    </div>
  );
};

export default ScheduleEndAfter;
